import { createActionGroup, emptyProps } from "@ngrx/store";

import { ActionSource } from "../../../state/action-sources";

export const TimeTravelActions = createActionGroup({
  source: ActionSource.TIME_TRAVEL,
  events: {
    'Toggle More Info Button Clicked': emptyProps(),
  }
})
